import styled from "styled-components";

export const ShiftReportHoursStyle = styled.div`
    overflow-x: auto;

    table {
        th span {
            display: block;
            width: 100%;
            text-align: center;
            min-width: max-content;
        }

        tbody {
            tr {
                td {
                    text-align: center;
                    width: 100vw;
                }

                td:has(.first-cell) {
                    width: max-content;
                }

                td:has(.last-rig) {
                    border-bottom: 2px solid black;
                }

                td div {
                    width: max-content;
                    display: inline-block;
                }

                td:has(.clickable) {
                    cursor: pointer;
                }

                td:has(.highlighted-red) {
                    background-color: #A51E36;
                    color: #FFFFFF;
                }

                td:has(.highlighted-green) {
                    background-color: #22AF47;
                    color: #FFFFFF;
                }
            }
        }
    }
`;
